module.exports = __webpack_public_path__ + "img/aboutus-case1.7ee2d726.png";